// Выбор языка подсказок.
//
// Интерфейс брокера пока только на русском, поэтому язык один. Когда появятся
// переводы, достаточно положить рядом файл со той же структурой, что `ru.js`,
// и добавить его в LOCALES — остальной код не меняется.
//
//   import kk from './kk';
//   const LOCALES = { ru, kk };

import ru from './ru';

const LOCALES = { ru };

export const DEFAULT_LOCALE = 'ru';

// Язык берём там же, где его будет брать остальное приложение, когда до него
// дойдут руки. Нет значения или нет перевода — показываем русский.
export const getLocale = () => {
  let name = DEFAULT_LOCALE;

  try {
    name = window.localStorage.getItem('lang') || DEFAULT_LOCALE;
  } catch (e) {
    name = DEFAULT_LOCALE;
  }

  return LOCALES[name] || LOCALES[DEFAULT_LOCALE];
};

export default LOCALES;
